import { render, staticRenderFns } from "./PluginListPanel.vue?vue&type=template&id=44d16e50&scoped=true"
import script from "./PluginListPanel.vue?vue&type=script&lang=ts"
export * from "./PluginListPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d16e50",
  null
  
)

export default component.exports